// Kiểm tra folder đã là git repo chưa. Đơn giản: check tồn tại của ".git"
// (folder hoặc file gitlink — cả hai đều hợp lệ với submodule).
import { existsSync, statSync } from "node:fs";
import { join } from "node:path";

export function checkFolderHasGit(folderPath: string): boolean {
  const gitPath = join(folderPath, ".git");
  if (!existsSync(gitPath)) return false;
  // .git có thể là directory (repo bình thường) hoặc file (submodule gitlink).
  // Cả 2 đều xem là "đã có git".
  const stat = statSync(gitPath);
  return stat.isDirectory() || stat.isFile();
}
